var BLOCK_ACTION = 'BLOCK_ACTION';
var BLOCK_PRESENCE = 'BLOCK_PRESENCE';
var ALL_BLOCKS = [BLOCK_ACTION, BLOCK_PRESENCE];
export default {
  BLOCK_ACTION: BLOCK_ACTION,
  BLOCK_PRESENCE: BLOCK_PRESENCE,
  ALL_BLOCKS: ALL_BLOCKS
};
var HOVER_EVENT = 'HOVER_EVENT';
var BLOCK_ACTION_EVENT = 'BLOCK_ACTION_EVENT';
var TABLE_ACTION_EVENT = 'TABLE_ACTION_EVENT';
export { HOVER_EVENT, BLOCK_ACTION_EVENT, TABLE_ACTION_EVENT };